/* Collection Filters & Popularity Sort — extracted for deferred loading.
   Watch/games-era filter paths (age, gender, category, color, durchmesser,
   zubehoerstyp) removed — the shop is software-only; their filter UIs and
   data-* attributes no longer exist. Live filters: vendor (Marke), discount
   (Rabatt), plus the data-sold popularity sort. */
if (!window.__collectionFilterInit) {
  window.__collectionFilterInit = true;
  document.addEventListener('DOMContentLoaded', function() {

    function syncCheckboxes(changed, cls, attr) {
      if (!changed) return;
      var val = changed.getAttribute(attr);
      var checked = changed.checked;
      document.querySelectorAll('.' + cls + '[' + attr + '="' + val + '"]').forEach(function(cb) {
        cb.checked = checked;
      });
    }

    function applyFilters() {
      var selectedVendors = new Set();
      document.querySelectorAll('.js-vendor-checkbox:checked').forEach(function(cb) {
        selectedVendors.add(cb.getAttribute('data-vendor-name'));
      });

      var selectedDiscounts = new Set();
      document.querySelectorAll('.js-discount-checkbox:checked').forEach(function(cb) {
        selectedDiscounts.add(cb.getAttribute('data-discount-value'));
      });

      // Update vendor count badges
      document.querySelectorAll('.vendor-filter-count').forEach(function(el) {
        if (selectedVendors.size > 0) {
          el.textContent = selectedVendors.size;
          el.className = 'vendor-filter-count bubble facets__bubble';
          el.style.display = '';
        } else {
          el.textContent = '';
          el.style.display = 'none';
        }
      });

      // Update discount count badges
      document.querySelectorAll('.discount-filter-count').forEach(function(el) {
        if (selectedDiscounts.size > 0) {
          el.textContent = selectedDiscounts.size;
          el.className = 'discount-filter-count bubble facets__bubble';
          el.style.display = '';
        } else {
          el.textContent = '';
          el.style.display = 'none';
        }
      });

      // Filter items — AND logic: must match all active filters
      var items = document.querySelectorAll('.product-grid__item');
      items.forEach(function(item) {
        var vendorMatch = selectedVendors.size === 0 || selectedVendors.has(item.getAttribute('data-vendor'));
        var itemDiscount = item.getAttribute('data-discount') || '';
        var discountMatch = selectedDiscounts.size === 0 || selectedDiscounts.has(itemDiscount);
        item.style.display = (vendorMatch && discountMatch) ? '' : 'none';
      });
    }

    // Event delegation for all filters
    document.addEventListener('change', function(e) {
      if (e.target.classList && e.target.classList.contains('js-vendor-checkbox')) {
        syncCheckboxes(e.target, 'js-vendor-checkbox', 'data-vendor-name');
        applyFilters();
      }
      if (e.target.classList && e.target.classList.contains('js-discount-checkbox')) {
        syncCheckboxes(e.target, 'js-discount-checkbox', 'data-discount-value');
        applyFilters();
      }
    });

    // Re-apply filters when infinite scroll loads new items
    var observer = new MutationObserver(function() {
      var hasActive = document.querySelector('.js-vendor-checkbox:checked') ||
                      document.querySelector('.js-discount-checkbox:checked');
      if (hasActive) {
        applyFilters();
      }
    });

    var productGrid = document.querySelector('.product-grid');
    if (productGrid) {
      observer.observe(productGrid, { childList: true, subtree: true });
    }

    // Live Popularity Sorting
    function sortProductsByMetafield() {
      var grid = document.querySelector('.collection-wrapper.grid');
      if (!grid) {
        grid = document.querySelector('results-list .collection-wrapper');
      }
      var searchStr = window.location.search || '';

      // Only auto-sort if no manual sort_by is enforced, or if it's best-selling/manual
      if (!searchStr.includes('sort_by') || searchStr.includes('sort_by=manual') || searchStr.includes('sort_by=best-selling')) {
        var itemsContainer = document.querySelector('.product-grid') || grid;
        if (!itemsContainer) return;

        var items = Array.from(itemsContainer.querySelectorAll('li.product-grid__item'));
        if (items.length <= 1) return;

        items.sort(function(a, b) {
          var countA = parseInt(a.getAttribute('data-sold') || '0', 10);
          var countB = parseInt(b.getAttribute('data-sold') || '0', 10);
          return countB - countA;
        });

        // Using a DocumentFragment ensures reflow is minimized
        var df = document.createDocumentFragment();
        items.forEach(function(item) {
          df.appendChild(item);
        });
        itemsContainer.appendChild(df);
      }
    }

    // Execute the sorting immediately
    sortProductsByMetafield();
  });
}
